var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('div',{staticClass:"feedback"},[_c('span',[_vm._v(_vm._s(_vm.$t('feedback.message')))]),_c('p',[_vm._v(" "+_vm._s(_vm.$t('feedback.tellUs'))+" ")]),_c('share-feedback-button',{attrs:{"feature":"automations"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }